import React from "react";
import { cn } from "@/lib/utils";
import { STATUS_STYLES } from "@/lib/format";

export function StatusBadge({ status, className }) {
  const s = STATUS_STYLES[status] || { label: status, cls: "bg-muted text-muted-foreground border-border" };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize",
        s.cls,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}
